import { render } from "./RealEstateSingle.vue?vue&type=template&id=5c8bf0b8&scoped=true"
import script from "./RealEstateSingle.vue?vue&type=script&lang=js"
export * from "./RealEstateSingle.vue?vue&type=script&lang=js"

import "./RealEstateSingle.vue?vue&type=style&index=0&id=5c8bf0b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8bf0b8"]])

export default __exports__